export const handleRowStyle = params => {
  const styleFlag = params.node.data.applyStyle;
  if (styleFlag) {
    return { fontWeight: '800 !important' };
  }
};
